import React from "react"

const FooterTags = () => {
  // useEffect(() => {
  //     const clientSlug = "we-celebrate"
  //     const existingScript = document.querySelector(`script[data-client="${clientSlug}"]`)
  //     if (existingScript) return
  //     const script = document.createElement("script")
  //     script.id = "ChatbotIA_script"
  //     script.src = "https://chatbot.spiral-studio.com/scripts/widget.latest.min.js"
  //     script.setAttribute("data-client", clientSlug)
  //     script.async = true
  //     document.body.appendChild(script)
  //     return () => {
  //       script.remove()
  //       const container = document.getElementById("ChatbotIA_container")
  //       if (container) container.remove()
  //     }
  // }, [])

  return null;
};
export default FooterTags;
